// extracted by mini-css-extract-plugin
export default {"hidden":"withLoader_hidden__Epfsq","default":"withLoader_default__bYMpN","loader":"withLoader_loader__ELnwS"};